import jwtDecode from 'jwt-decode';
import moment from 'moment';
import { TOKEN_USER } from "../constants";
import { MyJWTUser } from 'src/models/Login.Model';
import { clearAllCookies } from './cookie-utils';
import {useNavigate } from 'react-router-dom';




/**
 * Récupère le token stocké
 */
const getToken = (): string | null => {
  return localStorage.getItem(TOKEN_USER) || null;
};

/**
 * Supprime le token et les cookies associés
 */
const clearToken = (): void => {
  localStorage.removeItem(TOKEN_USER);
  clearAllCookies();
};



/**
 * Vérifie si le token est expiré (ou presque expiré)
 */
export const isExpired = (): boolean => {
  const token = getToken();
  if (!token) return true;

  try {
    const decoded = jwtDecode<MyJWTUser>(token);
    if (!decoded.exp) return true;

    // Expiration < 30s → on considère le token expiré
    return moment.unix(decoded.exp).diff(moment(), "seconds") < 30;
  } catch {
    clearToken();
    console.warn("⚠️ Token invalide ou corrompu");
    return true;
  }
};

/**
 * Safe decode d'un token générique
 */
export function safeDecode<T>(token: string): T | null {
  try {
    return jwtDecode<T>(token);
  } catch (e) {
    console.error("Erreur décodage JWT :", e);
    return null;
  }
}

/**
 * Décode le token et renvoie un utilisateur typé
 */
export const decodeToken = <T extends MyJWTUser>(): T | null => {
  const token = getToken();
  if (!token) return null;

  try {
    const decoded = safeDecode<any>(token);
    if (!decoded) return null;

    return {
      ...decoded,
      IsConsultant: decoded.IsConsultant?.toString().toLowerCase() === "true",
      IsPerimeterDDI: decoded.IsPerimeterDDI?.toString().toLowerCase() === "true",
    };
  } catch {
    clearToken();
    window.location.reload(); // ⚡ on force un refresh si token invalide
    return null;
  }
};



export const jwt = {
  getToken,
  clearToken,
  isExpired,
  decodeToken,
};